// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"ContactsGrid_gridContainer__2a692","gridOverlay":"ContactsGrid_gridOverlay__1Qso6"};